import { Box } from '@chakra-ui/react';
import { ParsedUrlQuery } from 'querystring';
import {
  DocsTemplate,
  DocsQuickstarts,
  DocsFooter,
  DocsHeader,
  DocsSidenav,
  DocsComponentReference,
  DocsAPIReference,
  DocsIntegrations,
  NextjsOverview
} from '@components/docs';
import { DOCS_CATEGORIES } from '@lib';
import { DocsCategory, DocsTemplateContent, DocsTutorialContent } from '@types';
import { useRouteScroll } from '@hooks';
import { useEffect } from 'react';
import { analytics, rudderTrack } from 'pages';

type Props = {
  data: DocsTemplateContent;
  query: ParsedUrlQuery;
  guides: Array<DocsTutorialContent>;
  navigation: Array<{
    name: string;
    navId: string;
    categories: Array<DocsCategory>;
  }>;
};

function renderTemplate(props: Props): JSX.Element {
  const { data, guides, query } = props;

  if (data.slug === '/docs/nextjs/overview') {
    return <NextjsOverview content={data} guides={[]} />;
  }
  switch (query.category) {
    case DOCS_CATEGORIES.quickstarts:
      return <DocsQuickstarts content={data} guides={guides} />;
    case DOCS_CATEGORIES.componentReference:
      return <DocsComponentReference content={data} />;
    case DOCS_CATEGORIES.apiReference:
      return <DocsAPIReference content={data} />;
    case DOCS_CATEGORIES.integrations:
      return <DocsIntegrations content={data} />;
    default:
      return <DocsTemplate content={props.data} />;
  }
}

export function DocsOverview(props: Props): JSX.Element {
  const { navigation } = props;
  const capitalize = (s: string) =>
    (s && s[0].toUpperCase() + s.slice(1)) || '';
  useEffect(() => {
    const mySubString = props.data.slug.substring(
      props.data.slug.indexOf('docs/') + 5,
      props.data.slug.lastIndexOf('/overview')
    );
    analytics.track(`Docs_${capitalize(mySubString)}_Overview Viewed`, {
      surface: 'Docs',
      location: 'Page'
    });
    rudderTrack(`Docs_${capitalize(mySubString)}_Overview Viewed`, {
      surface: 'Docs',
      location: 'Page'
    });
  }, []);

  useRouteScroll();

  return (
    <Box minH="100vh" bg="white" color="black">
      <DocsSidenav navigation={navigation} />
      <DocsHeader navigation={navigation} />
      {renderTemplate(props)}
      <DocsFooter />
    </Box>
  );
}
